/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_S5_TitleInputs */

const en_guide_what_is_json_s5_title = /** @type {(inputs: Guide_What_Is_Json_S5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Working with JSON in Practice`)
};

const ko_guide_what_is_json_s5_title = /** @type {(inputs: Guide_What_Is_Json_S5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`실전에서 JSON 다루기`)
};

const ja_guide_what_is_json_s5_title = /** @type {(inputs: Guide_What_Is_Json_S5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONを実践で活用する`)
};

/**
* | output |
* | --- |
* | "Working with JSON in Practice" |
*
* @param {Guide_What_Is_Json_S5_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_s5_title = /** @type {((inputs?: Guide_What_Is_Json_S5_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_S5_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_s5_title(inputs)
	if (locale === "ko") return ko_guide_what_is_json_s5_title(inputs)
	return ja_guide_what_is_json_s5_title(inputs)
});